export default __webpack_public_path__ + "f8655f1f24c7ee6e7f3812df40abd058.png";